import {
  setAllExamData,
  setExamInData,
  setSingleExam,
} from "../slices/examSlice";
import mainApi from "./mainApi";

const examApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getExamFilter: builder.query({
      query: () => ({
        url: "/api/exam/get_all_filters",
      }),
      providesTags: ["exam_question"],
    }),
    getQuestions: builder.query({
      query: ({
        database,
        university,
        years,
        unit,
        shift,
        subject,
        chapter,
        topic,
        page,
      }) => ({
        url: `/api/exam/question_bank_all_questions?database_type_pk=${database}&university_pk=${university}&year_pk=${years}&unit_pk=${unit}&shift_pk=${shift}&subject_pk=${subject}&chapter_pk=${chapter}&topic_pk=${topic}&page=${page}`,
      }),
      providesTags: ["exam_question"],
    }),
    createQuestionBank: builder.mutation({
      query: (questionBank) => ({
        url: "/api/exam/admin/exam_question_paper/",
        method: "POST",
        body: questionBank,
      }),
      invalidatesTags: ["exam_question"],
    }),
    getQuestionBank: builder.query({
      query: ({ page = 1, search = "" } = {}) => {
        let url = `/api/exam/admin/exam_question_paper/?page=${page}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        return { url };
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setAllExamData(data?.results || []));
        } catch (error) {
          console.error(error);
        }
      },
      providesTags: ["exam_question"],
    }),
    getSingleQuestionBank: builder.query({
      query: (id) => ({
        url: `/api/exam/admin/exam_question_paper/${id}`,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setExamInData(data));
          dispatch(setSingleExam(data));
        } catch (error) {
          console.error(error);
        }
      },
      providesTags: ["exam_question"],
    }),
    createUpdateQuestionOnExam: builder.mutation({
      query: ({ examId, data }) => ({
        url: `/api/exam/admin/exam_question_paper/${examId}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["exam_question"],
    }),
    deleteExamFull: builder.mutation({
      query: (examId) => ({
        url: `/api/exam/admin/exam_question_paper/${examId}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["exam_question"],
    }),
    postSharedExam: builder.mutation({
      query: (body) => ({
        url: "/api/exam/save_question_paper",
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["exam_question"],
    }),
  }),
});

export const {
  useGetExamFilterQuery,
  useGetQuestionsQuery,
  useCreateQuestionBankMutation,
  useGetQuestionBankQuery,
  useCreateUpdateQuestionOnExamMutation,
  useGetSingleQuestionBankQuery,
  useDeleteExamFullMutation,
  usePostSharedExamMutation,
} = examApi;
